<template>
	<div class="user-card" @click.prevent="openQRCode">
		<slot></slot>
	</div>
</template>

<script>

	import Alert from '../../modules/Alert'

	export default {

		props: {
			number: {
				required: true
			},
			nkey: {
				required: true
			},
		},

		data() {
			return {
				open: false,
			}
		},

		methods: {

			openQRCode() {
				const el = document.getElementById('qrcode-'+this.nkey)
				Alert.CardQRCode(el)
				el.classList.remove('d-none');
			},

			test() {
				console.log('test');
			}

		}

	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Account/card.vue